/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllGamesQuestsSummary } from './AllGamesQuestsSummary';
import {
    AllGamesQuestsSummaryFromJSON,
    AllGamesQuestsSummaryFromJSONTyped,
    AllGamesQuestsSummaryToJSON,
    AllGamesQuestsSummaryToJSONTyped,
} from './AllGamesQuestsSummary';
import type { AllGamesQuestsGameData } from './AllGamesQuestsGameData';
import {
    AllGamesQuestsGameDataFromJSON,
    AllGamesQuestsGameDataFromJSONTyped,
    AllGamesQuestsGameDataToJSON,
    AllGamesQuestsGameDataToJSONTyped,
} from './AllGamesQuestsGameData';

/**
 * 
 * @export
 * @interface GetAllGamesQuestsResponse
 */
export interface GetAllGamesQuestsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof GetAllGamesQuestsResponse
     */
    success?: boolean;
    /**
     * 
     * @type {AllGamesQuestsSummary}
     * @memberof GetAllGamesQuestsResponse
     */
    summary?: AllGamesQuestsSummary;
    /**
     * 
     * @type {{ [key: string]: AllGamesQuestsGameData; }}
     * @memberof GetAllGamesQuestsResponse
     */
    games?: { [key: string]: AllGamesQuestsGameData; };
    /**
     * 
     * @type {string}
     * @memberof GetAllGamesQuestsResponse
     */
    timestamp?: string;
}

/**
 * Check if a given object implements the GetAllGamesQuestsResponse interface.
 */
export function instanceOfGetAllGamesQuestsResponse(value: object): value is GetAllGamesQuestsResponse {
    return true;
}

export function GetAllGamesQuestsResponseFromJSON(json: any): GetAllGamesQuestsResponse {
    return GetAllGamesQuestsResponseFromJSONTyped(json, false);
}

export function GetAllGamesQuestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllGamesQuestsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'summary': json['summary'] == null ? undefined : AllGamesQuestsSummaryFromJSON(json['summary']),
        'games': json['games'] == null ? undefined : (mapValues(json['games'], AllGamesQuestsGameDataFromJSON)),
        'timestamp': json['timestamp'] == null ? undefined : json['timestamp'],
    };
}

export function GetAllGamesQuestsResponseToJSON(json: any): GetAllGamesQuestsResponse {
    return GetAllGamesQuestsResponseToJSONTyped(json, false);
}

export function GetAllGamesQuestsResponseToJSONTyped(value?: GetAllGamesQuestsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'summary': AllGamesQuestsSummaryToJSON(value['summary']),
        'games': value['games'] == null ? undefined : (mapValues(value['games'], AllGamesQuestsGameDataToJSON)),
        'timestamp': value['timestamp'],
    };
}

